module.exports = __webpack_public_path__ + "media/call2.00c5b82e.mp4";